import { MSAL_INSTANCE } from '@azure/msal-angular';
import { BrowserCacheLocation, IPublicClientApplication, LogLevel, PublicClientApplication } from '@azure/msal-browser';
import { environment } from '@env';

export function authDetailedLoggerCallback(logLevel: LogLevel, message: string) {
  if (logLevel === LogLevel.Error) {
    console.error(`[Auth-Error] ${message}`);
    return;
  }
  if (logLevel === LogLevel.Warning) {
    console.warn(`[Auth-Warning] ${message}`);
    return;
  }
  if (environment.msalModule.showDetailedAuthLogs) {
    console.log(`[Auth-${LogLevel[logLevel]}] ${message}`);
  }
}

const msalInstanceFactory = (): IPublicClientApplication => {
  const redirectUrl =
    environment.msalModule.redirectUri[0] == '/'
      ? window.location.origin + environment.msalModule.redirectUri
      : environment.msalModule.redirectUri;

  return new PublicClientApplication({
    auth: {
      clientId: environment.msalModule.clientID,
      authority: environment.msalModule.authority,
      redirectUri: redirectUrl,
      knownAuthorities: [environment.msalModule.authority.split('/')[2]],
      postLogoutRedirectUri: `/`,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
    },
    system: {
      loggerOptions: {
        loggerCallback: authDetailedLoggerCallback,
        logLevel: environment.msalModule.showDetailedAuthLogs ? LogLevel.Info : LogLevel.Warning,
        piiLoggingEnabled: false,
      },
    },
  });
};

export const msalInstanceProvider = {
  provide: MSAL_INSTANCE,
  useFactory: msalInstanceFactory,
};
